<template>
<div>
    <el-alert class="mb-3" v-if="alert.message" effect="dark" :type="alert.type" :description="alert.message" show-icon :closable="false"></el-alert>
    <v-content-layout>
        <template #header>
            <FilterOption />
            <div>
                <el-input class="ml-2" prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable></el-input>
            </div>
            <v-spacer></v-spacer>
            <el-button icon="mdi mdi-file-download" type="primary" @click="downloadTemplate"> Download Import Template</el-button>
            <el-button icon="mdi mdi-upload" type="primary" @click="viewImportForm"> Import</el-button>
            <!-- Export temporarily hidden -->
            <el-button class="ml-2" icon="mdi mdi-sync" type="success" @click="loadExtensivLogs({})"> Refresh</el-button>
        </template>
        <template #body>
            <e-table :data="items" :total="items.length" :headers="headers" :search="search" :height="window.height - 170" :loading="loading">
                <template #actions="{scope}">
                    <el-button
                      v-if="scope.row.statusLabel === 'ERROR' || scope.row.lastError"
                      type="danger"
                      size="mini"
                      @click="showError(scope.row)"
                    >
                      View Error
                    </el-button>
                    <el-dropdown size="mini" v-else-if="scope.row.statusLabel !== 'Processing'" trigger="click" split-button type="primary" @click="viewBills(scope.row)">
                        View POs
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-download" @click.native="$downloadFile(`extensiv_${scope.row.batchId}.xlsx`, scope.row.fileLink)">Download Template</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <span v-else>-</span>
                </template>

                <template #footer>
                    <span id="qbStatus" class="ml-2" style="font-size:13px;color:white">
                        Status last checked: {{ lastCheckedText }}
                    </span>
                </template>
            </e-table>
        </template>
    </v-content-layout>
    <BillsList ref="billsList" />
    <ImportForm ref="importForm" @onSuccess="onImportSuccess" @onError="onImportError" />
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import * as type from '../../store/types';
import FilterOption from './components/FilterOption';
import BillsList from './components/BillsList';
import ImportForm from './components/ImportForm';

export default {
    components: {
        FilterOption,
        BillsList,
        ImportForm
    },
    props: {
        handleDisconnect: Function
    },
    data: () => ({
        search: '',
        timer: '',
        alert: {
            type: "error",
            message: ""
        }
    }),
    computed: {
        ...mapGetters({
            headers: `extensivlogs/headers`,
            items: `extensivlogs/items`,
            loading: 'extensivlogs/loading',
        }),
        exportTableColumns() {
            return this.headers.map(e => {
                return {
                    label: e.text,
                    field: e.value
                }
            })
        },
        lastCheckedText() {
            const now = new Date();
            const yyyy = now.getUTCFullYear();
            const mm = String(now.getUTCMonth() + 1).padStart(2, '0');
            const dd = String(now.getUTCDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd} 00:00:00 GMT`;
        },
    },
    mounted() {
        this.loadExtensivLogs({});
        this.timer = setInterval(() => {
            this.loadExtensivLogs({})
        }, 60000);
    },
    methods: {
        ...mapActions({
            loadExtensivLogs: `extensivlogs/${type.Extensiv_GET_LOGS}`,
            disconnect: `extensiv/${type.Extensiv_DISCONNECT}`
        }),
        downloadTemplate() {
            // File is served from /public; encode spaces to be safe.
            const url = '/Extensiv_PO_upload_template%20v1.xlsx';
            window.open(url, '_blank');
        },
        viewBills(items) {
            this.$refs['billsList'].viewBillsList(items.batchId);
        },
        showError(row) {
            const msg = row.lastError || 'No error details available.';
            this.$alert(msg, 'Extensiv Import Error', { type: 'error' });
        },
        viewImportForm() {
            this.$refs['importForm'].viewImportForm();
        },
        onImportSuccess(success) {
            this.alert = success
            this.loadExtensivLogs({})
        },
        onImportError(error) {
            this.alert = error
            this.loadExtensivLogs({})
        }
    }
}
</script>
